import React, {useState,useRef,useEffect} from 'react';
import {Toolbar} from "primereact/toolbar";
import {SlideMenu} from "primereact/slidemenu";
import {Divider} from "primereact/divider";
import {asIcon, flatArray, visibleDim, wrapArray} from "../../utils";
import {useField, useFormikContext} from "formik";
import {withFormikFormControl} from "../../FormikFormControl";
import {Navigator} from "../../DisplayRendering/Navigator";
import _ from 'lodash';
import {Dialog} from "primereact/dialog";


const getDownloads = (googleDocUrl, type, options ) => {
    const all = getAllDownloads(googleDocUrl, type, false, false)
    if(options && options.length){
        return all.filter( a => options.includes(a.value) )
    }
    return all
}
const getAllDownloads = (googleDocUrl,type, importMode = false, addTs = false) => {
    const verb = importMode ? 'Import' : 'Download'
    let ts = addTs ? '&ts=' + Date.now() : ''
    switch (type) {
        case 'document':
        case 'documents':
            return [
                {
                    label: `${verb} as PDF`,
                    url: `${googleDocUrl}/export?format=pdf${ts}`,
                    target: '_blank',
                    value: 'pdf',
                },
                {
                    label: `${verb} as HTML`,
                    url: `${googleDocUrl}/export?format=html${ts}`,
                    target: '_blank',
                    value: 'html',
                },
                {
                    label: `${verb} as MS Word`,
                    url: `${googleDocUrl}/export?format=doc${ts}`,
                    target: '_blank',
                    value: 'doc',
                },
                {
                    label: `${verb} as Text`,
                    url: `${googleDocUrl}/export?format=txt${ts}`,
                    target: '_blank',
                    value: 'txt',
                },
            ]
        case 'spreadsheet':
        case 'spreadsheets':
            return [
                {
                    label: `${verb} as PDF`,
                    url: `${googleDocUrl}/export?format=pdf${ts}`,
                    target: '_blank',
                    value: 'pdf',
                },
                {
                    label: `${verb} as MS Excel`,
                    url: `${googleDocUrl}/export?format=xlsx${ts}`,
                    target: '_blank',
                    value: 'xlsx',
                },
                {
                    label: `${verb} as CSV`,
                    url: `${googleDocUrl}/export?format=csv${ts}`,
                    target: '_blank',
                    value: 'csv',
                },
            ]
        case 'presentation':
        case 'presentations':
            ts = ts.replace('&', '?')
            return [
                {
                    label: `${verb} as PDF`,
                    url: `${googleDocUrl}/export/pdf${ts}`,
                    target: '_blank',
                    value: 'pdf',
                },
                {
                    label: `${verb} as Powerpoint`,
                    url: `${googleDocUrl}/export/pptx${ts}`,
                    target: '_blank',
                    value: 'pptx',
                },
            ]
    }
    return []
}
const googleDocTypes = [
    { label: 'Auto Detect', value: 'auto' },
    { label: 'Google Docs', value: 'document' },
    { label: 'Google Sheets', value: 'spreadsheet' },
    { label: 'Google Slides', value: 'presentation' },
    { label: 'Google Drive Folder', value: 'folder' },
]
const extractGoogleDoc = (gUrl: string, googleDocDetectType = 'auto', googleFolderMode = 'list' ) => {
    let url = '',
        id = '',
        type = ''
    if (gUrl) {
        if(googleDocDetectType === 'folder' ||
            ( googleDocDetectType === 'auto' && (gUrl.includes('/folders/') || gUrl.includes('/embeddedfolderview/') ) )){
            type = 'folder'
            let items = gUrl.split('/')
            id = items.pop()
            url = `https://drive.google.com/embeddedfolderview?id=${id}#${googleFolderMode}`
        }else {

            const path = 'https://docs.google.com/'
            const stripped = gUrl.replace(path, '')
            let [gType, gId = null] = stripped.split('/d/')
            if (!gId) {
                gId = gType
                gType = !googleDocDetectType || googleDocDetectType === 'auto' ? 'document' : googleDocDetectType
            }
            gId = gId.split('/')[0]
            type = gType
            if (gType === 'spreadsheet' || gType === 'form') gType += 's'
            url = path + gType + '/d/' + gId
            id = gId
        }
    }
    return { url, id, type }
}
const GoogleFieldComp = (props) => {
    const refDownload = useRef(null)
    const [mode, setMode] = useState(null)
    const [isFs, setFs] = useState(false)
    const {name, value, extraConfig, details} = props
    const {source:ori_source = 'field', static_url, file_type = 'auto', title, folder_view_mode, downloadable = true, download_types = null, view_modes:view_modes_raw = null, view_mode='', emptyMessage, height = null, width = null, source_field, source_sub_field} = extraConfig
    const is_folder = file_type === 'folder'
    const source = ori_source || 'field'
    let view_modes = wrapArray(view_modes_raw)
    const [vw,vh] = visibleDim()
    const canSwitchModes = view_modes.includes('edit') && view_modes.includes('preview')
    const can_open = view_modes.includes('external')
    const can_fs = view_modes.includes('fullscreen')
    const {
        values,
        setFieldValue,
        setFieldError, errors
    } = useFormikContext();
    let srcValue = source === 'static' ? static_url : (source_field ? values[source_field] : null)
    useEffect( () => {
        if(source === 'field' && source_sub_field?.id && Array.isArray(srcValue)){
            let items = []
            for(let i of srcValue){
                let sub = i[source_sub_field?.id] ?? i[source_sub_field?.name]
                if(sub) {
                    const toVal = (val) => ({tableRecordId: i.tableRecordId, ...(_.isObject(val as any) ? val : {value: val})})
                    if (Array.isArray(sub)) {
                        items = items.concat(sub.map(toVal))
                    } else if (!_.isEmpty(sub)) {
                        items.push(toVal(sub))
                    }
                }
            }
            srcValue = items
        }
        const urlList = flatArray(srcValue,true)
        setFieldValue(name, urlList)
    }, [srcValue])

    useEffect( () => {
        if(view_mode && view_modes.includes(view_mode))setMode(view_mode)
        if(!mode){
            if(view_modes?.includes('edit'))setMode('edit')
            else if(view_modes?.includes('preview'))setMode('preview')
        }
    }, [view_mode])
    const showDownloads = (event) => {
        const to = event.currentTarget.getBoundingClientRect()
        const rect = {
            ...to,
            left: to.left - 162,
            top: to.top,
            right: to.right,
            bottom: to.bottom,
            x: to.x,
            y: to.y,
            width: to.width,
            height: to.height,
        }
        refDownload.current.toggle({
            ...event,
            currentTarget: {
                ...event.currentTarget,
                offsetWidth: event.currentTarget.offsetWidth,
                offsetHeight: event.currentTarget.offsetHeight,
                getBoundingClientRect: () => rect,
                parentNode: null,
            },
        })
    }
    const toolbar = (loc, val, downloads) => {
        if (loc === 'left') {
            return (
                <>
                    <div >
                        <h2
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {is_folder ? 'Google Drive Folder' :  ''}
                        </h2>

                    </div>
                </>
            )
        } else if (loc === 'right') {
            return (
                <>
                    {!is_folder && downloadable && downloads.length ? asIcon('download', "Download File", false, downloads.length === 1 ? downloads[0].url : (e) => showDownloads(e), !val) : ''}
                    <SlideMenu
                        ref={refDownload}
                        model={downloads}
                        popup
                        style={{ width: '180px' }}
                        menuWidth={180}
                        viewportHeight={150}
                    />


                    {!is_folder && canSwitchModes &&  (
                        <>
                            {downloadable && <Divider layout="vertical" style={{ height: '10px' }} />}
                            {asIcon(
                                'file-edit',
                                `${canSwitchModes ? 'Switch to ' : ''}${mode === (canSwitchModes ? 'edit' : 'preview') ? 'Preview Mode' : 'Edit Mode'}`,
                                canSwitchModes && mode === 'edit',
                                () => canSwitchModes ? setMode( mode === 'preview' ? 'edit' : 'preview') : null,
                                !val,
                            )}
                            </> )}
                    {can_fs && (
                        <>
                            { (canSwitchModes || downloadable) && <Divider layout="vertical" style={{ height: '10px' }} />}
                            {asIcon(isFs ? 'window-minimize' : 'window-maximize', 'Full Screen', isFs, () => setFs(!isFs))}
                        </> )}

                    {can_open && (
                        <>
                            { (canSwitchModes || downloadable || can_fs) && <Divider layout="vertical" style={{ height: '10px' }} />}
                            {asIcon('external-link', 'Open in New Tab', false, val)}
                            </> )}
                </>
            )
        }
    }
    const renderItem = (src) => {
        const { url: googleDocUrl, id: googleDocId, type: googleDocType } = extractGoogleDoc( _.isObject(src as any) ? src.value : src, file_type, folder_view_mode )
        let urlUse = !is_folder && googleDocUrl ? googleDocUrl + (mode === 'preview' ? '/preview' : '/edit') : googleDocUrl
        const downloads = getDownloads(googleDocUrl,googleDocType,  download_types)
        console.log('**Google renderItem**', {src,googleDocUrl, googleDocId, googleDocType})
        return googleDocId ? (
            <>
            <Toolbar style={{ height: '0px', position: 'relative', background: 'none', border: 'none', top: '-50px', padding: 0, paddingRight: '15px' }}  end={toolbar('right', urlUse, downloads)} />
            <div style={{width: width || '100%', height: `${isFs ? vh - 185 : height || 500}px`}}>
                <iframe src={urlUse} style={{width: '100%', height:'100%', border: 'none'}} />
            </div>
            </>
        ) : <p>{emptyMessage || 'No URL Provided'}</p>
    }
    console.log("**GOOGLE FILE**", value, source, source_field, source_sub_field, values, srcValue)
    if(!value) {
        return <></>
    }else  if( value.length === 0 ){
        return <p>{emptyMessage || 'No URL Provided'}</p>
    }else {
        let inner = <></>
        if( value.length === 1){
            inner = renderItem(value[0])
        }else{
            inner = <Navigator value={value} render={item => renderItem(item)} extraConfig={extraConfig}/>
        }
        if(isFs){
            return <Dialog header={title} onHide={() => setFs(false)} draggable={false} maximized={true} visible={true} closable={true}>{inner}</Dialog>
        }else{
            return inner
        }
    }

}

export default withFormikFormControl({  })(GoogleFieldComp);